import React, { useEffect } from "react";
import { auth } from "../firebase/config";
import { useAuthStore } from "../stores/Auth.store";
import { useUserSessionStore } from "../stores/UserSession.store";
import { useUsers } from "../hooks/collections/useUsers";
import { Collections } from "../@core/constants/FirebasePaths";
import { Loader } from "../components/Loader/Loader";
import { IUser } from "../@core/interfaces/IUser";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const setAuth = useAuthStore((state) => state.setAuth);
  const uid = useAuthStore((state) => state.uid);
  const setUser = useUserSessionStore((state) => state.setUser);
  const user = useUserSessionStore((state) => state.user);
  const { docListener, subscribe } = useUsers({ loadData: false });

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        setAuth(user.uid);
      } else {
        setAuth(null);
        setUser(null);
      }
    });
  }, []);

  useEffect(() => {
    if (uid) subscribe(uid, [], Collections.users._path);
  }, [uid]);

  useEffect(() => {
    if (docListener !== undefined) {
      setUser(docListener as IUser);
    }
  }, [docListener]);

  if (uid && !user) {
    return <Loader/>;
  }

  return <>{children}</>;
};
